export default "__VITE_ASSET__oWdZxV27__"